import React from 'react'

interface Props {
    value: number
}

class Duration extends React.PureComponent<Props> {
    public render() {
        let minutes = Math.floor(this.props.value / 60)
        const seconds = this.props.value - minutes * 60

        if (minutes >= 60) {
            const hours = Math.floor(minutes / 60)
            minutes = minutes - hours * 60

            if (hours > 24) {
                const days = Math.round(hours / 24)
                return <span>{days} days</span>
            }
            return (
                <span>
                    {hours} hours, {minutes} minutes
                </span>
            )
        }

        if (minutes > 0) {
            return <span>{minutes} minutes</span>
        }

        return <span>{seconds} seconds </span>
    }
}
export default Duration
